import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import Header from './components/Header';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import Home from './pages/Home';
import About from './pages/About';
import Services from './pages/Services';
import Contact from './pages/Contact';
import Privacy from './pages/Privacy';
import Terms from './pages/Terms';
import SmsPolicy from './pages/SmsPolicy';
import CookiePolicy from './pages/CookiePolicy';
import FAQ from './pages/FAQ';
import Resources from './pages/Resources';
import SmsConsent from './pages/SmsConsent';
import ApplicationSupport from './pages/services/ApplicationSupport';
import DocumentPreparation from './pages/services/DocumentPreparation';
import LoanApplicationGuide from './pages/resources/LoanApplicationGuide';
import './App.css';

function App() {
  return (
    <HelmetProvider>
      <Router>
        <div className="App">
          <ScrollToTop />
          <Header />
          <main>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/services" element={<Services />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/resources" element={<Resources />} />
              <Route path="/faq" element={<FAQ />} />
              <Route path="/privacy" element={<Privacy />} />
              <Route path="/terms" element={<Terms />} />
              <Route path="/sms-policy" element={<SmsPolicy />} />
              <Route path="/cookie-policy" element={<CookiePolicy />} />
              <Route path="/sms-consent" element={<SmsConsent />} />
              <Route path="/services/application-support" element={<ApplicationSupport />} />
              <Route path="/services/document-preparation" element={<DocumentPreparation />} />
              <Route path="/resources/loan-application-guide" element={<LoanApplicationGuide />} />
            </Routes>
          </main>
          <Footer />
        </div>
      </Router>
    </HelmetProvider>
  );
}

export default App;
